import { useQuery } from '@tanstack/vue-query'

export type PackageInfo = {
  id: string
  name: string
  tier: string | null
  billingPeriod: string | null
  price: number
}

export type DeclineStatusData = {
  isDeclined: boolean
  failureCode: string | null
  failureMessage: string | null
  originalPackage: PackageInfo | null
  monthlyPackage: PackageInfo | null
}

export const useDeclineStatus = () => {
  const authStore = useAuthStore()
  return useQuery({
    queryKey: ['decline-status', authStore.getUser?.id],
    queryFn: async () => {
      const response = await $fetch<{ success: boolean; data: DeclineStatusData }>(
        '/api/payment/decline-status',
        {
          headers: { Authorization: `Bearer ${authStore.token}` },
        }
      )
      return response.data
    },
    enabled: computed(() => !!authStore.getUser?.id),
    staleTime: 0,
    gcTime: 0,
  })
}

export default useDeclineStatus

